import { Box } from 'components/Box/Box';
import { Button } from 'components/Button/Button';
import { SaveButton } from 'components/SaveButton/SaveButton';
import { ShareListingButton } from 'components/ShareListingButton/ShareListingButton';
import type { ApiOrg } from 'modules/listing/api/org/types/ApiOrg';
import { ListingActionsDropdown } from 'modules/listing/components/ListingActionsDropdown/ListingActionsDropdown';
import { trackClicked } from 'utils/analytics/track/trackClicked';

import { orgHasListings } from './utils/orgHasListings';

type Props = {
  org: ApiOrg;
  isPreview: boolean;
  mobile: boolean;
};

export function ViewOrgPageActionButtons({ org, isPreview, mobile }: Props) {
  return (
    <Box display="flex" flexWrap="wrap" position="relative">
      {orgHasListings(org) && (
        <Box m="4px">
          <Button
            type="link"
            href="#opportunities"
            variant="primary"
            onClick={() =>
              trackClicked('See Opportunities', { type: 'Button Top' })
            }
          >
            {getText('See opportunities')}
          </Button>
        </Box>
      )}
      <Box m={1}>
        <SaveButton
          disabled={isPreview}
          listingId={org.id}
          listingType={org.type}
          listingName={org.name}
          orgId={org.id}
          orgType={org.orgType}
        />
      </Box>
      {!mobile && (
        <Box m={1}>
          <ShareListingButton
            listingId={org.id}
            listingType="ORG"
            listingUrl={org.url}
            disabled={isPreview}
          />
        </Box>
      )}
      <Box m={1}>
        <ListingActionsDropdown
          listingId={org.id}
          listingType="ORG"
          listingUrl={org.url}
        />
      </Box>
    </Box>
  );
}
